import { AxiosError } from 'axios';

import { useAlertsStore } from '../components/alert/alerts.composable';

export function handleError(error: unknown): void {
  const alerts = useAlertsStore();
  const axiosErrorMessage = (error as AxiosError<any, any>)?.response?.data?.message?.message;

  if (error instanceof AxiosError && axiosErrorMessage) {
    alerts.error(axiosErrorMessage);
  } else {
    alerts.somethingWentWrong();
  }
}
